<template>
  <m-dialog ref="dlg" @save="save" title="Kelola Persetujuan">
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row dense>
              <v-col cols="12" md="6" sm="12">
                <label class="body-1 mb-2 primary--text"> Nama Grup Persetujuan </label>
                <v-text-field
                  v-model="form.nama"
                  dense
                  outlined
                  placeholder="Nama grup persetujuan"
                  data-vv-name="nama"
                  data-vv-as="Nama Grup"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.nama')"
                />
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <label class="body-1 mb-2 primary--text"> Kategori Persetujuan </label>
                <v-select
                  v-model="form.k_persetujuan"
                  :items="[{ k_persetujuan: 1, nama: 'Persetujuan Cuti' }]"
                  item-text="nama"
                  item-value="k_persetujuan"
                  placeholder="Pilih Kategori"
                  dense
                  outlined
                  data-vv-name="k_persetujuan"
                  data-vv-as="Kategori Persetujuan"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.k_persetujuan')"
                ></v-select>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-card>
                  <v-card-text>
                    <div class="body-1 black--text">
                      <v-icon color="black" left>mdi-bell-outline</v-icon>Grup Persetujuan
                    </div>
                    <div class="my-2">
                      <v-alert type="info" dense text>
                        Pemeringkatan dilakukan untuk persetujuan berjenjang dalam setiap kategori persetujuan. Tingkat
                        1 adalah level terendah dalam jenjang persetujuan
                      </v-alert>
                      <v-alert v-if="tingkats.length === 0" type="warning" dense text>
                        Belum ada tingkat, silakan tambahkan dengan menekan tombol
                        <v-icon color="black" left>mdi-plus</v-icon>
                      </v-alert>
                      <v-simple-table v-else>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th width="40%">Tingkat</th>
                              <th>Grup pengguna yang Menyetujui</th>
                              <th width="5%">Aksi</th>
                            </tr>
                            <tr v-for="(ti, t) in tingkats" :key="t">
                              <td> Persetujuan Tingkat {{ Number(t) + 1 }} </td>
                              <td>
                                <v-select
                                  class="mt-3"
                                  v-model="ti.group_id"
                                  outlined
                                  dense
                                  :items="availableGroup"
                                  :data-vv-name="`tingkat_${t + 1}`"
                                  :data-vv-as="`Pertanyaan ke ${t + 1}`"
                                  v-validate="'required'"
                                  :error-messages="errors.collect(`form.tingkat_${t + 1}`)"
                                >
                                  <template v-slot:selection="{ item }">
                                    <v-chip small>{{ item.text }}</v-chip>
                                  </template>
                                </v-select>
                              </td>
                              <td>
                                <v-btn class="mt-n3" color="red" depressed small icon @click="onDelete(t)">
                                  <v-icon>mdi-delete-outline</v-icon>
                                </v-btn>
                              </td>
                            </tr>
                          </thead>
                        </template>
                      </v-simple-table>
                    </div>
                    <div class="text-right">
                      <v-btn color="primary" text small link @click="onAddTingkat">
                        <v-icon left>mdi-plus</v-icon> Tambah Persetujuan
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col class="mt-5" cols="12" md="12" sm="12">
                <div class="d-flex justify-space-between">
                  <div>
                    <label class="body-1 mt-2 primary--text"> Grup pengguna yang Disetujui</label>
                  </div>
                  <div>
                    <v-text-field v-model="keyword" outlined dense rounded placeholder="Cari Nama Group"></v-text-field>
                  </div>
                </div>
                <div class="d-flex justify-space-between my-3 mx-3">
                  <div>
                    <span class="primary--text">{{ selectedItems.length }}</span> Grup Terpilih
                  </div>
                  <div class="primary--text" style="cursor: pointer" @click="onShowSelected"> Lihat Anggota Grup </div>
                </div>
                <v-data-table
                  :headers="headers"
                  :items="listGroup"
                  :items-per-page="100"
                  item-key="user_id"
                  hide-default-footer
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.user_id">
                        <td>
                          <v-checkbox
                            v-model="select[item.group_id]"
                            :value="1"
                            style="margin: 0px; padding: 0px"
                            hide-details
                          />
                        </td>
                        <td>{{ item.nama }}</td>
                        <td>{{ item.keterangan }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" width="700" close>
      <v-toolbar dark color="primary">
        <v-toolbar-title class="white--text">Lihat Pengguna yang Disetujui</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="pa-5">
        <v-card-text>
          <div class="d-flex justify-space-between my-3 mx-3">
            <div>
              <span class="primary--text">{{ selectedItems.length }}</span> Daftar Grup Terpilih
            </div>
          </div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <td></td>
                  <td class="text-left">Nama Grup</td>
                  <td class="text-left">Deskripsi</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in selectedItems" :key="i">
                  <td>
                    <i
                      aria-hidden="true"
                      class="v-icon notranslate mdi mdi-checkbox-marked theme--light primary--text"
                      style="cursor: pointer"
                      @click="onDiselect(item)"
                    ></i>
                  </td>
                  <td class="text-left">
                    {{ getDeepObj(groups.find((data) => Number(data.group_id) === Number(item)) || {}, 'nama') }}
                  </td>
                  <td class="text-left">
                    {{
                      getDeepObj(groups.find((data) => Number(data.group_id) === Number(item)) || {}, 'keterangan') ||
                      ''
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </m-dialog>
</template>
<script>
export default {
  $_veeValidate: {
    validator: 'new',
  },

  props: {
    kategoris: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {},
      tingkats: [],
      headers: [
        { width: '15%' },
        { text: 'Nama', align: 'left', value: 'nama' },
        { text: 'Deskripsi', align: 'left', value: 'deskripsi' },
      ],
      selection: [],
      select: {},
      id: null,
      keyword: '',
      dialog: false,
    }
  },
  computed: {
    availableGroup() {
      let groups = this.groups || []
      return groups.map((item) => {
        return {
          value: item.group_id,
          text: item.nama,
          disabled: this.tingkats.findIndex((s) => Number(s.group_id) === Number(item.group_id)) > -1,
        }
      })
    },
    listGroup() {
      return this.groups.filter((item) => {
        return (
          item.nama.toLowerCase().includes(this.keyword.toLowerCase()) ||
          this.selectedItems.includes(Number(item.group_id))
        )
      })
    },
    selectedItems() {
      let temp = []

      Object.keys(this.select).forEach((key) => {
        if (this.select[key]) temp.push(Number(key))
      })

      return temp
    },
  },
  methods: {
    open(obj) {
      this.reset()
      this.$validator.reset()
      this.$refs.dlg.open()

      this.$nextTick(() => {
        if (obj) this.initForm(obj)
      })
    },
    initForm(obj) {
      this.$set(this, 'id', obj.id)
      this.$set(this.form, 'k_persetujuan', Number(this.getDeepObj(obj, 'persetujuan.mPersetujuan.k_persetujuan')))
      this.$set(this.form, 'nama', this.getDeepObj(obj, 'persetujuan.nama'))

      const pengguna = obj.pengguna || []
      const petugas = (obj.petugas || []).sort((a, b) => Number(a.tingkat) - Number(b.tingkat))
      pengguna.forEach((item) => {
        this.$set(this.select, item.group_id, 1)
      })

      petugas.forEach((item) => {
        this.tingkats.push({ group_id: item.group_id })
      })
    },
    reset() {
      this.form = {}
      this.tingkats = []
      this.selection = []
      this.select = {}
      this.id = null
      this.keyword = ''
    },
    save() {
      let petugas = []
      let pengguna = []
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          if (this.tingkats.length === 0) {
            this.$error('Harap pilih tingkat persetujuan')
            return
          }

          if (this.selectedItems.length === 0) {
            this.$error('Harap pengguna yang disetujui')
            return
          }

          this.tingkats.forEach((item, i) => {
            if (item.group_id) petugas.push({ tingkat: i + 1, group_id: item.group_id })
          })

          this.selectedItems.forEach((key) => {
            pengguna.push({ group_id: key })
          })

          this.$store
            .dispatch('persetujuan/update', {
              organisasi_id: this.organisasi_id,
              obj: {
                id: this.id || null,
                params: Object.assign({}, this.form, {
                  petugas: petugas,
                  pengguna: pengguna,
                }),
              },
            })
            .then(() => {
              this.$success('Aksi berhasil dilakukan')
              this.$refs.dlg.resolve()
              this.$emit('reload')
            })
        })
    },
    onAddTingkat() {
      this.tingkats.push({ group_id: '' })
    },
    onDelete(index) {
      this.tingkats.splice(index, 1)
    },
    onShowSelected() {
      this.dialog = true
    },
    onDiselect(item) {
      this.$delete(this.select, item)
    }
  },
}
</script>
